import { useContext, useEffect, useState } from 'react'
import { TenantsContext } from '../context/tenants.context'
import { getDeviceId } from '../services/firebase.service'

export const useDeviceId = () => {
  const { tenant } = useContext(TenantsContext)
  const [loading, setLoading] = useState<boolean>(false)
  const [deviceId, setDeviceId] = useState<string | null>(() => {
    const stored = localStorage.getItem('deviceId')
    if (stored && stored.startsWith('[object')) {
      localStorage.removeItem('deviceId')
      return null
    }
    return stored
  })

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true)
        await getDeviceId(tenant).then((res) => {
          setDeviceId(res.data.data)
          localStorage.setItem('deviceId', res.data.data)
        })
      } catch (error) {
        console.error(error)
      } finally {
        setLoading(false)
      }
    }
    if (!deviceId) {
      fetchData()
    }
  }, [deviceId])

  return { deviceId, loading }
}
